export const Toggle = 'atlantis-toggle';